import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./components/font/iconfont.css"
// import "./components/fontNewProject/iconfont.css"
import './assets/gloabl.css'
//引入全部的UI组件
// import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Message } from 'element-ui';



Vue.prototype.$message.success = function (msg) {
  return Message.success({
    duration: 800
  })
}
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;
import Loading from './utils/loading'
Vue.use(Loading)
import baiduMap from 'vue-baidu-map'
Vue.use(baiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'Mpzza2beL7Md3ZiBXeHxGfsKxr8s1dXk'
})
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'item') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}
import VueDraggableResizable from 'vue-draggable-resizable'

// 可选择导入默认样式
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
Vue.component('vue-draggable-resizable', VueDraggableResizable)
//按需引入UI
import "./elementuiConfig"
Vue.config.productionTip = false;
//在main.js中添加配置
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥
  ak: 'Mpzza2beL7Md3ZiBXeHxGfsKxr8s1dXk',

  styleId: 'e0e1aac969fbb46b11a23f9b85f76798'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
